import { Injectable } from '@angular/core';
import { createState, Store } from '@ngneat/elf';
import { withActiveId, withEntities } from '@ngneat/elf-entities';
import {
  createRequestsStatusOperator,
  withRequestsStatus,
} from '@ngneat/elf-requests';
import { UnitOfMeasurement } from '@prisma/client';
import { CRUDRepository } from '../../shared/crud/repository';
import { loadList } from './unit-of-measurement.actions';

type StatusPaths = 'list' | 'item';

const { state, config } = createState(
  withEntities<UnitOfMeasurement>(),
  withActiveId(),
  withRequestsStatus<StatusPaths>()
);

export const store = new Store({ name: 'uoms', config, state });
export const trackRequestsStatus = createRequestsStatusOperator(store);

@Injectable({ providedIn: 'root' })
export class UnitOfMeasurementRepository extends CRUDRepository<
  UnitOfMeasurement,
  typeof store
> {
  constructor() {
    super(store, { loadListAction: loadList });
  }

  public override searchEntity(entity: UnitOfMeasurement, searchText: string) {
    searchText = searchText.toLowerCase();
    if (entity.name) {
      if (entity.name?.toLocaleLowerCase().indexOf(searchText) !== -1)
        return true;
    }
    return false;
  }
}
